import { SvgIcon, SvgIconProps } from '@mui/material'

const BalanceColoredIcon = ({ fill = '#122937', ...props }: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.597107 3.73684C0.597107 2.54933 0.597107 1.95557 0.828212 1.502C1.0315 1.10303 1.35587 0.778653 1.75484 0.575367C2.20841 0.344261 2.80217 0.344261 3.98969 0.344261H9.9267C11.1142 0.344261 11.708 0.344261 12.1615 0.575367C12.5605 0.778653 12.8849 1.10303 13.0882 1.502C13.3193 1.95557 13.3193 2.54933 13.3193 3.73684V9.67385C13.3193 10.8614 13.3193 11.4551 13.0882 11.9087C12.8849 12.3077 12.5605 12.632 12.1615 12.8353C11.708 13.0664 11.1142 13.0664 9.9267 13.0664H3.98968C2.80217 13.0664 2.20841 13.0664 1.75484 12.8353C1.35587 12.632 1.0315 12.3077 0.828212 11.9087C0.597107 11.4551 0.597107 10.8614 0.597107 9.67385V3.73684Z"
          fill={fill}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.78497 5.9986C9.39463 5.9986 9.07819 5.68216 9.07819 5.29182V4.58503H8.3714C7.98105 4.58503 7.66461 4.26859 7.66461 3.87824C7.66461 3.48789 7.98105 3.17146 8.3714 3.17146H9.07819V2.46467C9.07819 2.07432 9.39463 1.75788 9.78497 1.75788C10.1753 1.75788 10.4918 2.07432 10.4918 2.46467V3.17146H11.1985C11.5889 3.17146 11.9053 3.48789 11.9053 3.87824C11.9053 4.26859 11.5889 4.58503 11.1985 4.58503H10.4918V5.29182C10.4918 5.68216 10.1753 5.9986 9.78497 5.9986ZM2.7171 3.17146C2.32675 3.17146 2.01031 3.48789 2.01031 3.87824C2.01031 4.26859 2.32675 4.58503 2.7171 4.58503H5.54425C5.9346 4.58503 6.25104 4.26859 6.25104 3.87824C6.25104 3.48789 5.9346 3.17146 5.54425 3.17146H2.7171ZM2.57072 7.97258C2.84674 7.69657 3.29425 7.69657 3.57027 7.97258L4.13068 8.53299L4.69108 7.97258C4.9671 7.69657 5.41461 7.69657 5.69063 7.97258C5.96665 8.2486 5.96665 8.69612 5.69063 8.97213L5.13022 9.53254L5.69063 10.0929C5.96665 10.369 5.96665 10.8165 5.69063 11.0925C5.41461 11.3685 4.9671 11.3685 4.69108 11.0925L4.13068 10.5321L3.57027 11.0925C3.29425 11.3685 2.84674 11.3685 2.57072 11.0925C2.2947 10.8165 2.2947 10.369 2.57072 10.0929L3.13113 9.53254L2.57072 8.97213C2.2947 8.69612 2.2947 8.2486 2.57072 7.97258Z"
          fill="#FFF"
        />
        <g opacity="0.5">
          <path
            d="M7.66449 8.11892C7.66449 7.72857 7.98093 7.41213 8.37128 7.41213H11.1984C11.5888 7.41213 11.9052 7.72857 11.9052 8.11892C11.9052 8.50927 11.5888 8.82571 11.1984 8.82571H8.37128C7.98093 8.82571 7.66449 8.50927 7.66449 8.11892Z"
            fill="#88949B"
          />
          <path
            d="M8.37128 10.2393C7.98093 10.2393 7.66449 10.5557 7.66449 10.9461C7.66449 11.3364 7.98093 11.6529 8.37128 11.6529H11.1984C11.5888 11.6529 11.9052 11.3364 11.9052 10.9461C11.9052 10.5557 11.5888 10.2393 11.1984 10.2393H8.37128Z"
            fill="#88949B"
          />
        </g>
      </svg>
    </SvgIcon>
  )
}

export default BalanceColoredIcon
